import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1084Status: 'idle',
    startProcess1084Error: undefined as any,
    loadUserParamsProcess1084Status: 'idle',
    loadUserParamsProcess1084Error: undefined as any,

    process1084List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1084 = createAsyncThunk('process1084Slice/startProcess1084', async ({ process1084 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1084/`,
        prepareData(process1084),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1084Status } = getState().process1084Slice
        return startProcess1084Status !== 'pending'
    }
})

export const loadUserParamsProcess1084 = createAsyncThunk('process1084Slice/loadUserParamsProcess1084', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1084/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1084Status } = getState().process1084Slice
        return loadUserParamsProcess1084Status !== 'pending'
    }
})

const Process1084Slice = createSlice({
    name: 'process1084Slice',
    initialState,
    reducers: {
        resetstartProcess1084: (state) => {
            state.job = undefined
            state.startProcess1084Error = undefined
        },
        resetstartProcess1084Error: (state) => {
            state.startProcess1084Error = undefined
        },
        resetloadUserParamsProcess1084: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1084Error = undefined
        },
        resetloadUserParamsProcess1084Error: (state) => {
            state.loadUserParamsProcess1084Error = undefined
        },
        removeFromProcess1084ListById: (state, action) => {
            state.process1084List = state.process1084List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1084ListByIds: (state, action) => {
            state.process1084List = state.process1084List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1084List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1084Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1084List = []
            state.startProcess1084Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1084.pending, (state) => {
            state.startProcess1084Status = 'pending'
            state.startProcess1084Error = undefined
        })
        builder.addCase(startProcess1084.fulfilled, (state, action) => {
            state.startProcess1084Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1084.rejected, (state, action) => {
            state.startProcess1084Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1084Error = action.error.message
            } else {
                state.startProcess1084Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1084.pending, (state) => {
            state.loadUserParamsProcess1084Status = 'pending'
            state.loadUserParamsProcess1084Error = undefined
        })
        builder.addCase(loadUserParamsProcess1084.fulfilled, (state, action) => {
            state.loadUserParamsProcess1084Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1084.rejected, (state, action) => {
            state.loadUserParamsProcess1084Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1084Error = action.error.message
            } else {
                state.loadUserParamsProcess1084Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1084,
    resetstartProcess1084Error,
    resetloadUserParamsProcess1084,
    resetloadUserParamsProcess1084Error,
    removeFromProcess1084ListById,
    removeFromProcess1084ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1084Slice.actions
export default Process1084Slice.reducer
